import { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import Reveal, { SectionLabel } from "./Reveal"
import { testimonials } from "./data"

const DURATION = 9000

const Depoimentos = () => {
  const [active, setActive] = useState(0)
  const [paused, setPaused] = useState(false)
  const t = testimonials[active]

  useEffect(() => {
    if (paused) return
    const id = setTimeout(() => setActive((a) => (a + 1) % testimonials.length), DURATION)
    return () => clearTimeout(id)
  }, [active, paused])

  return (
    <section
      className="k-section k-testimonials"
      id="depoimentos"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="k-container k-testimonials__inner">
        <Reveal className="k-testimonials__side">
          <SectionLabel index="04" light>
            Depoimentos
          </SectionLabel>
          <h2 className="k-h2">
            Quem já <em>confiou</em> na KJR.
          </h2>

          <ul className="k-testimonials__tabs">
            {testimonials.map((item, i) => (
              <li key={item.company}>
                <button className={i === active ? "is-active" : ""} onClick={() => setActive(i)}>
                  <span className="k-testimonials__tabname">{item.company}</span>
                  <span className="k-testimonials__tabproj">{item.project}</span>
                  {i === active && (
                    <motion.span
                      key={`${active}-${paused}`}
                      className="k-testimonials__timer"
                      initial={{ scaleX: 0 }}
                      animate={{ scaleX: paused ? 0 : 1 }}
                      transition={{ duration: paused ? 0 : DURATION / 1000, ease: "linear" }}
                    />
                  )}
                </button>
              </li>
            ))}
          </ul>
        </Reveal>

        <div className="k-testimonials__stage">
          <span className="k-testimonials__quote" aria-hidden>
            “
          </span>
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={t.company}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="k-stars" aria-label={`${t.rating} de 5 estrelas`}>
                {"★★★★★".slice(0, t.rating)}
              </div>
              <p>{t.feedback}</p>
              <footer>
                <span className="k-testimonials__logo">
                  <img src={t.logo} alt="" />
                </span>
                <span>
                  <strong>{t.company}</strong>
                  <small>{t.project}</small>
                </span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
      </div>
    </section>
  )
}

export default Depoimentos
